
<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} ANALISA GABUNGAN</h4>
        <feather-icon icon="XIcon" @click.stop="closeSide" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <vs-row>
          <vs-col vs-align="center" class="pr-2" vs-w="6">
            <vs-select
              class="w-full"
              label="Bidang"
              v-model="dataBidang"
              @change="pilihDivisi"
              @click.prevent="changeClickDivisi"
              >
                <vs-select-item value="pilih" text="Pilih"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in list_bidang"/>
            </vs-select>
          </vs-col>
          <vs-col vs-align="center" class="" vs-w="6">
            <vs-select
              class="w-full"
              label="Divisi"
              v-model="dataDivisi"
              @change="pilihKelompok"
              @click.prevent="changeClickKelompok"
              >
                <vs-select-item value="pilih" text="Pilih"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in list_divisi"/>
            </vs-select>
          </vs-col>
        </vs-row>

        <vs-row class="mt-4">
          <vs-col vs-align="center" class="pr-2" vs-w="6">
            <vs-select
              class="w-full"
              label="Kelompok"
              v-model="dataKelompok"
              @change="pilihSub"
              @click.prevent="changeClickSub"
              >
                <vs-select-item value="pilih" text="Pilih"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in list_kelompok"/>
            </vs-select>
          </vs-col>
          <vs-col vs-align="center" class="" vs-w="6">
            <vs-select
              class="w-full"
              label="Sub"
              v-model="dataSub"
              @change="pilihSubKode()"
              >
                <vs-select-item value="pilih" text="Pilih"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in list_sub"/>
            </vs-select>
          </vs-col>
        </vs-row>
        
        <vs-row>
          <vs-col vs-align="left" vs-w="10">
            <vs-input label="Satuan Pekerjaan" v-model="dataAnalisa" class="w-full mt-5" name="item-analisa" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('item-analisa')">{{ errors.first('item-analisa') }}</span>

            <vs-textarea label="Keterangan" v-model="dataKeterangan" class="w-full mt-2" name="item-keterangan" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('item-keterangan')">{{ errors.first('item-keterangan') }}</span>
          </vs-col>
          <vs-col vs-align="left" vs-w="2">
            <vs-input label="Kode" v-model="dataKode" class="w-full mt-5 pl-2" name="item-kode" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('item-kode')">{{ errors.first('item-kode') }}</span>
          </vs-col>
        </vs-row>

        <vs-row class="mt-4">
          <vs-col vs-align="left" vs-w="2">
            <vs-input label="Ukuran" v-model="dataUkuran" class="w-full pr-2" name="item-ukuran" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('item-ukuran')">{{ errors.first('item-ukuran') }}</span>
          </vs-col>

          <vs-col vs-align="left" vs-w="6">
            <vs-select
              label="Satuan"
              v-model="dataSatuan"
              v-validate="'required'"
              class="w-full"
              >
                <vs-select-item value="0" text="Tidak ada"/>
                <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listSatuan"/>
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('satuan')">{{ errors.first('satuan') }}</span>
          </vs-col>
          <vs-col vs-align="left" vs-w="2">
            <vs-button class="py-3 mt-6" @click.stop="tambahSatuan=true" >+</vs-button>
          </vs-col>

          <vs-col vs-align="left" vs-w="2">
            <vs-input label="Persen" v-model="dataPersentase" @input="eventTotal()" class="w-full pr-2" name="item-persen" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('item-persen')">{{ errors.first('item-persen') }}</span>
          </vs-col>
        </vs-row>

        <vs-divider class="mt-base">AHSP</vs-divider>

        <!-- AHSP -->
          <vs-row id="ahsp" :key="`ahsp-${indexahsp}`" v-for="(ahsp,indexahsp) in rowAHSP" class="mb-2">
            <vs-col vs-align="left" vs-w="12" class="" v-if="ahsp.add">
              <vs-row>
                <vs-col vs-align="center" class="pr-2" vs-w="6">
                  <vs-select
                    class="w-full"
                    label="Bidang"
                    v-model="ahsp.bidang"
                    @change="AHSPpilihDivisi(indexahsp)"
                    @click.prevent="AHSPchangeClickDivisi(indexahsp)"
                    >
                      <vs-select-item value="pilih" text="Pilih"/>
                      <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in list_bidang"/>
                  </vs-select>
                  <input type="hidden" v-model="ahsp.divisichange" disabled />
                </vs-col>
                <vs-col vs-align="center" class="" vs-w="6">
                  <vs-select
                    class="w-full"
                    label="Divisi"
                    v-model="ahsp.divisi"
                    @change="AHSPpilihKelompok(indexahsp)"
                    @click.prevent="AHSPchangeClickKelompok(indexahsp)"
                    >
                      <vs-select-item value="pilih" text="Pilih"/>
                      <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in list_divisi_ahsp"/>
                  </vs-select>
                  <input type="hidden" v-model="ahsp.kelompokchange" disabled />
                </vs-col>
              </vs-row>

              <vs-row class="mt-4">
                <vs-col vs-align="center" class="pr-2" vs-w="6">
                  <vs-select
                    class="w-full"
                    label="Kelompok"
                    v-model="ahsp.kelompok"
                    @change="AHSPpilihSub(indexahsp)"
                    @click.prevent="AHSPchangeClickSub(indexahsp)"
                    >
                      <vs-select-item value="pilih" text="Pilih"/>
                      <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in list_kelompok_ahsp"/>
                  </vs-select>
                  <input type="hidden" v-model="ahsp.kelompokchange" disabled />
                </vs-col>
                <vs-col vs-align="center" class="" vs-w="6">
                  <vs-select
                    class="w-full"
                    label="Sub"
                    v-model="ahsp.sub"
                    @change="AHSPpilihAnalisa(indexahsp)"
                    >
                      <vs-select-item value="pilih" text="Pilih"/>
                      <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in list_sub_ahsp"/>
                  </vs-select>
                  <input type="hidden" v-model="ahsp.subchange" disabled />
                </vs-col>
              </vs-row>

              <vs-row class="mt-4">
                <vs-col vs-align="center" class="pr-2" vs-w="6">
                  <vs-select
                    class="w-full"
                    label="AHSP"
                    v-model="ahsp.task_name"
                    @change="pilihAHSP(indexahsp, ahsp.task_name)"
                    >
                      <vs-select-item value="pilih" text="Pilih"/>
                      <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.task_title}`" v-for="itemx in listAnalisa"/>
                  </vs-select>
                  <input type="hidden" v-model="ahsp.analisachange" disabled />
                  <input type="hidden" v-model="ahsp.task_unit" disabled />
                </vs-col>
                <vs-col vs-align="left" vs-w="2" class="pt-6">
                  <vs-input-number v-model="ahsp.task_quantity" @input="updateItemAHSP(ahsp.task_quantity, ahsp.task_price, indexahsp)"/>
                </vs-col>
                <vs-col vs-align="center" class="pt-8" vs-w="3">
                  <input type="hidden" v-model="ahsp.task_total" class="w-full" disabled />
                  <span class="font-semibold">{{ ahsp.task_total | currency }} / {{ ahsp.term_satuan }}</span>
                </vs-col>
                <vs-col vs-align="left" vs-w="1" class="pt-8">
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="" @click.prevent="deleteListAHSP(indexahsp)"/>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col vs-align="left" vs-w="12" class="pt-2" v-else>
              <vs-row>
                <vs-col vs-align="center" class="pt-2" vs-w="6">
                  <p>{{ ahsp.task_title}}</p>
                  <input type="hidden" v-model="ahsp.analisachange" disabled />
                  <input type="hidden" v-model="ahsp.task_unit" disabled />
                </vs-col>
                <vs-col vs-align="left" vs-w="2">
                  <vs-input-number v-model="ahsp.task_quantity" @input="updateItemAHSP(ahsp.task_quantity, ahsp.task_price, indexahsp)"/>
                </vs-col>
                <vs-col vs-align="center" class="pt-2" vs-w="3">
                  <input type="hidden" v-model="ahsp.task_total" class="w-full" disabled />
                  <span class="font-semibold">{{ ahsp.task_total | currency }} / {{ ahsp.term_satuan }}</span>
                </vs-col>
                <vs-col vs-align="left" vs-w="1" class="pt-2">
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="" @click.prevent="deleteListAHSP(indexahsp)"/>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-divider class="mt-base"></vs-divider>
          </vs-row>

          <div class="flex flex-wrap items-center justify-center">
            <!--
            <span v-if="rowAHSP.length > 0">Jumlah AHSP</span>
            <span class="font-bold" v-if="rowAHSP.length > 0">{{totalAHSP | currency}} {{totalAHSPArray}}</span>
            -->
            <vs-button class="mt-2 mr-4" @click="addRowAHSP">+</vs-button>
          </div>
        <!-- // AHSP -->

        <vs-divider class="mt-base"></vs-divider>
          <vs-row class="mt-4">
            <vs-col vs-align="left" vs-w="3" class="pt-2">
              <span class="font-semibold">Lama Pengerjaan</span>
            </vs-col>

            <vs-col vs-align="left" vs-w="2">
              <vs-input-number v-model="dataHari"/>
            </vs-col>

            <vs-col vs-align="left" vs-w="3" class="pt-2">
              <span class="font-semibold">Hari</span>
            </vs-col>
          </vs-row>

        <vs-divider class="mt-base"></vs-divider>

          <div class="flex flex-wrap items-center justify-between mr-6">
            <h5>Jumlah</h5>
            <h4 class="font-bold">{{dataJumlah | currency}}</h4>
          </div>
          <div class="flex flex-wrap items-center justify-between mr-6">
            <h5>Overhead dan Profit {{dataPersentase}} %</h5>
            <h4 class="font-bold">{{dataOverhead | currency}}</h4>
          </div>
          <div class="flex flex-wrap items-center justify-between mr-6 mt-4">
            <h5 class="font-bold">Harga Satuan Pekerjaan</h5>
            <h4 class="font-bold">{{dataTotal | currency}}</h4>
          </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="closeSide">Cancel</vs-button>
    </div>

    <vs-prompt
      color="success"
      title="Tambah Satuan"
      @accept="satuanAdd"
      @close="close"
      :active.sync="tambahSatuan"
      style="z-index: 52011;">
      <div class="con-exemple-prompt">
        <vs-input placeholder="Satuan" data-vv-name="addsatuan" name="addsatuan" v-validate="'required'" v-model="addSatuan"/>
        <span class="text-danger text-sm" v-show="errors.has('addsatuan')">{{ errors.first('addsatuan') }}</span>
       </div>
    </vs-prompt>

  </vs-sidebar>

</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import { CurrencyDirective } from 'vue-currency-input'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default () { return { };}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
  },
  directives: {
    currency: CurrencyDirective
  },
  data () {
    return {

      dataId: null,
      dataAnalisa: null,
      dataParent: 0,
      dataKode: null,
      dataUkuran: 1,
      dataSatuan: 0,
      dataPersentase: 15,
      dataOverhead: 0,
      dataJumlah: 0,
      dataTotal: 0,
      dataHari: 0,
      dataKeterangan: null,

      dataBidang: 'pilih',
      changeBidang: false,
      dataDivisi: 'pilih',
      changeDivisi: false,
      dataKelompok: 'pilih',
      changeKelompok: false,
      dataSub: 'pilih',
      changeSub: false,

      list_sub: [],
      list_bidang: [],
      list_divisi: [],
      list_kelompok: [],

      listSatuan: [],
      addSatuan: null,
      tambahSatuan: false,

      pilihArray: null,

      keyrowAHSP: 0,
      rowAHSP: [],
      IDAHSPArray: [],
      totalAHSPArray: [],
      totalAHSP: 0,

      list_sub_ahsp: [],
      list_divisi_ahsp: [],
      list_kelompok_ahsp: [],

      dataAHSP: 'pilih',
      changeAHSP: false,
      listAnalisa : [],

      settings: {
        maxScrollbarLength: 80,
        wheelSpeed: .80
      },
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id, task_title, kode, task_quantity, pekerjaan_sub, task_unit, task_price, task_total, task_parent, ahsp, total_ahsp, persentase, profit, pekerjaan_bidang, pekerjaan_divisi, pekerjaan_kelompok, hari, keterangan  } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataAnalisa = task_title
        if (task_parent != 0) {
          this.dataParent = task_parent
        } else {
          this.dataParent = id
        }
        this.dataKode = kode
        this.dataUkuran = task_quantity
        this.dataSatuan = task_unit
        this.dataPersentase = persentase

        this.dataBidang = pekerjaan_bidang
        this.dataDivisi = pekerjaan_divisi
        this.dataKelompok = pekerjaan_kelompok
        this.dataSub = pekerjaan_sub

        // pengganti overhead
        this.dataOverhead = profit

        this.dataJumlah = task_price
        this.dataTotal = task_total
        this.dataHari = hari
        this.dataKeterangan = keterangan

        for (let i=0; i < ahsp.length; i++) {
          let b = this.keyrowAHSP + 1
          this.rowAHSP.push({
            idAHSP: b,
            add: false,
            bidang: ahsp[i].pekerjaan_bidang,
            divisi: ahsp[i].pekerjaan_divisi,
            kelompok: ahsp[i].pekerjaan_kelompok,
            sub: ahsp[i].pekerjaan_sub,

            task_name: ahsp[i].task_name,
            task_quantity: ahsp[i].task_quantity,
            task_total: ahsp[i].task_total,
            task_title: ahsp[i].task_title,
            task_unit: ahsp[i].task_unit,
            term_satuan: ahsp[i].nama_satuan,
            task_price: ahsp[i].task_price
          })
          this.IDAHSPArray.push(parseInt(ahsp[i].task_name))
          //this.totalAHSPArray.push(ahsp[i].task_total)
          this.keyrowAHSP++
        }
        this.totalAHSP = total_ahsp

        //this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataAnalisa && this.dataKode && this.dataUkuran && this.dataBidang && this.dataDivisi && this.dataKelompok && this.dataSub && this.dataSatuan && this.dataPersentase && this.dataOverhead && this.dataTotal && this.dataHari && this.dataKeterangan
    },
    validateSatuan() {
      return !this.errors.any() && this.addSatuan !== null
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    }),
  },
  mounted(){
    let configs = {
      headers: {
        'Authorization': 'Bearer ' + this.user.api_token,
      },
    }
    this.axios.get('/term-list-sort/pekerjaan_bidang/ASC', configs).then((response) => {
      let {data} = response.data
      this.list_bidang = data
    })
    this.axios.get('/term-list-sort/satuan/ASC', configs).then((response) => {
      let {data} = response.data
      this.listSatuan = data
    })
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataAnalisa = null
      this.dataParent = 0
      this.dataKode = null
      this.dataUkuran = 1
      this.dataSatuan = 0
      this.dataPersentase = 15
      this.dataOverhead = 0
      this.dataTotal = 0
      this.dataHari = 0
      this.dataJumlah = 0
      this.dataKeterangan = null

      this.changeBidang = false
      this.changeDivisi = false
      this.changeKelompok = false
      this.changeSub = false
      this.dataBidang = 'pilih'
      this.dataDivisi = 'pilih'
      this.dataKelompok = 'pilih'
      this.dataSub = 'pilih'
      this.list_divisi = []
      this.list_kelompok = []
      this.list_sub = []

      this.addSatuan = null
      this.tambahSatuan = false

      this.keyrowAHSP = 0
      this.rowAHSP = []
      this.IDAHSPArray = []
      this.totalAHSPArray = []
      this.totalAHSP = 0
    },
    changeClickDivisi () {
      this.changeDivisi = true
    },
    pilihDivisi () {
      this.list_divisi = []
      this.list_kelompok = []
      this.list_sub = []
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      if (this.dataBidang != 'pilih') {
        this.axios.get('/term-parent/'+this.dataBidang, configs).then((response) => {
          let {data} = response.data
          this.list_divisi = data
        })
      }
      if (this.changeDivisi === true) {
        this.dataDivisi = 'pilih'
        this.dataKelompok = 'pilih'
        this.dataSub = 'pilih'
      }
    },
    changeClickKelompok () {
      this.changeKelompok = true
    },
    pilihKelompok () {
      this.list_kelompok = []
      this.list_sub = []
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      if (this.dataDivisi != 'pilih') {
        //this.dataKelompok = 'pilih'
        this.axios.get('/term-parent/'+this.dataDivisi, configs).then((response) => {
          let {data} = response.data
          this.list_kelompok = data
        })
      }
      if (this.changeKelompok === true) {
        this.dataKelompok = 'pilih'
        this.dataSub = 'pilih'
      }
    },
    changeClickSub () {
      this.changeSub = true
    },
    pilihSub () {
      this.list_sub = []
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      if (this.dataKelompok != 'pilih') {
        this.axios.get('/term-parent/'+this.dataKelompok, configs).then((response) => {
          let {data} = response.data
          this.list_sub = data
        })
      }
      if (this.changeSub === true) {
        this.dataSub = 'pilih'
      }
    },
    searchArrayIdSub(nameKey, myArray){
      for (var i=0; i < myArray.length; i++) {
        if (myArray[i].id === nameKey) {
          return myArray[i];
        }
      }
    },
    pilihSubKode () {
      if (this.changeSub === true) {
        let sub = this.searchArrayIdSub(this.dataSub, this.list_sub)
        this.dataKode = sub.kode + '.'
      }
    },
    satuanAdd() {
      this.$vs.loading()
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      let formData = {
        name : this.addSatuan,
        term_group: 0,
        parent: 0,

        taxonomy: 'satuan'
      }
      this.axios.post('/term-add', formData, configs)
      .then((response) => {
        this.listSatuan = []
        this.addSatuan = null
        this.loadSatuan()
        this.$vs.notify({
          title: response.message,
          color  : 'success',
          text  : 'Satuan telah bertambah',
        })
        this.$vs.loading.close()
      })
      .catch((error) => {
        this.$vs.loading.close()
        let { data } = error.response
        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    loadSatuan () {
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/term-list/satuan', configs)
      .then((response) => {
        let {data} = response.data
        this.listSatuan = data
      })
      .catch((error) => {
        let data = error.data
        this.listSatuan = data
      })
    },
    //AHSP

      AHSPchangeClickDivisi(indexahsp) {
        this.rowAHSP[indexahsp].divisichange = true
      },
      AHSPpilihDivisi (indexahsp) {
        this.list_divisi = []
        this.list_kelompok = []
        this.list_sub = []
        let configs = {
          headers: {
            'Authorization': 'Bearer ' + this.user.api_token,
          },
        }
        if (this.rowAHSP[indexahsp].bidang != 'pilih') {
          this.axios.get('/term-parent/'+this.rowAHSP[indexahsp].bidang, configs).then((response) => {
            let {data} = response.data
            this.list_divisi_ahsp = data
          })
        }
        if (this.rowAHSP[indexahsp].divisichange === true) {
          this.rowAHSP[indexahsp].divisi = 'pilih'
          this.rowAHSP[indexahsp].kelompok = 'pilih'
          this.rowAHSP[indexahsp].sub = 'pilih'
        }
      },
      AHSPchangeClickKelompok (indexahsp) {
        this.rowAHSP[indexahsp].kelompokchange = true
      },
      AHSPpilihKelompok (indexahsp) {
        this.list_kelompok = []
        this.list_sub = []
        let configs = {
          headers: {
            'Authorization': 'Bearer ' + this.user.api_token,
          },
        }
        if (this.rowAHSP[indexahsp].divisi != 'pilih') {
          this.axios.get('/term-parent/'+this.rowAHSP[indexahsp].divisi, configs).then((response) => {
            let {data} = response.data
            this.list_kelompok_ahsp = data
          })
        }
        if (this.rowAHSP[indexahsp].kelompokchange === true) {
          this.rowAHSP[indexahsp].kelompok = 'pilih'
          this.rowAHSP[indexahsp].sub = 'pilih'
        }
      },
      AHSPchangeClickSub (indexahsp) {
        this.rowAHSP[indexahsp].subchange = true
      },
      AHSPpilihSub (indexahsp) {
        this.list_sub = []
        let configs = {
          headers: {
            'Authorization': 'Bearer ' + this.user.api_token,
          },
        }
        if (this.rowAHSP[indexahsp].kelompok != 'pilih') {
          this.axios.get('/term-parent/'+this.rowAHSP[indexahsp].kelompok, configs).then((response) => {
            let {data} = response.data
            this.list_sub_ahsp = data
          })
        }
        if (this.rowAHSP[indexahsp].subchange === true) {
          this.rowAHSP[indexahsp].sub = 'pilih'
        }
      },
      AHSPpilihAnalisa (indexahsp) {
        this.listAnalisa = []
        let configs = {
          headers: {
            'Authorization': 'Bearer ' + this.user.api_token,
          },
        }
        if (this.rowAHSP[indexahsp].sub != 'pilih') {
          this.axios.get('/task-list-analisa-sub/'+this.rowAHSP[indexahsp].sub, configs).then((response) => {
            let {data} = response.data
            this.listAnalisa = data
          })
        }
        if (this.rowAHSP[indexahsp].analisachange === true) {
          this.rowAHSP[indexahsp].task_name = 'pilih'
        }
      },
      searchArrayIdAHSP(nameKey, myArray){
        for (var i=0; i < myArray.length; i++) {
          if (myArray[i].id === nameKey) {
            return myArray[i];
          }
        }
      },
      reduceAHSP(total, num) {
        return total + num;
      },
      addRowAHSP() {
        this.changeAHSP = true
        document.createElement('vs-row')
        let c = this.keyrowAHSP + 1;
        this.rowAHSP.push({
          add: true,
          idAHSP: c,
          bidang: 'pilih',
          divisi: 'pilih',
          divisichange: false,
          kelompok: 'pilih',
          kelompokchange: false,
          sub: 'pilih',
          subchange: false,
          task_name: 'pilih',
          analisachange: false,

          id: 0,
          task_title: null,
          task_price: 0,
          term_satuan: null,
          task_unit: null,
          task_quantity: 0,
          task_total: 0
        });
        this.keyrowAHSP++
      },
      pilihAHSP(indexahsp, id) {
        if (this.changeAHSP === true) {
          if (this.IDAHSPArray.includes(id) === true) {
            this.rowAHSP.splice(indexahsp)
            this.$vs.notify({
              title: 'Sudah ada',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: 'top-right',
              time: 4000
            })
            this.IDAHSPArray.splice(indexahsp)
          } else {
            this.IDAHSPArray.splice(indexahsp)
            //let AHSP = this.searchArrayIdAHSP(id, this.listAnalisa)
            const AHSP = this.listAnalisa.find((analisa) => analisa.id === id)
            this.IDAHSPArray.push(id)
            this.totalAHSPArray.splice(indexahsp)
            this.rowAHSP[indexahsp].task_title = AHSP.task_title
            this.rowAHSP[indexahsp].task_price = AHSP.task_total
            this.rowAHSP[indexahsp].term_satuan = AHSP.nama_satuan
            this.rowAHSP[indexahsp].task_unit = AHSP.id
            this.rowAHSP[indexahsp].task_quantity = 0
            this.rowAHSP[indexahsp].task_total = 0
            /*
            if (this.totalAHSPArray.length != 0 ) {
              this.totalAHSP = this.totalAHSPArray.reduce(this.reduceAHSP)
            } else {
              this.totalAHSP = 0
            }
            */
          }
        }
      },
      updateItemAHSP (event, price, indexahsp) {
        //alert(indexahsp)
        let tambahHarga = Math.abs(event * price)
        this.rowAHSP[indexahsp].task_total = tambahHarga
        //this.totalAHSPArray.splice(indexahsp,1)
        //this.totalAHSPArray.push(this.rowAHSP[indexahsp].task_total)
        //this.totalAHSP = this.totalAHSPArray.reduce(this.reduceAHSP)
        this.totalAHSP = 0
        for(var i = 0, len = this.rowAHSP.length; i < len; i++) {
          this.totalAHSP += this.rowAHSP[i].task_total;
        }
        this.eventTotal()
      },
      deleteListAHSP (indexahsp) {
        this.rowAHSP.splice(indexahsp, 1)
        this.IDAHSPArray.splice(indexahsp,1)
        /*
        this.totalAHSPArray.splice(indexahsp,1)
        if (this.totalAHSPArray.length > 0) {
          this.totalAHSP = this.totalAHSPArray.reduce(this.reduceAHSP)
          this.eventTotal()
        }
        */
        this.totalAHSP = 0
        for(var i = 0, len = this.rowAHSP.length; i < len; i++) {
          this.totalAHSP += this.rowAHSP[i].task_total;
        }
        this.eventTotal()
        this.changeAHSP = false
      },
    close() {
      this.$emit('closed', false)
    },
    closeSide() {
      this.initValues()

      this.changeBidang = false
      this.changeDivisi = false
      this.changeKelompok = false
      this.changeSub = false
      this.dataBidang = 'pilih'
      this.dataDivisi = 'pilih'
      this.dataKelompok = 'pilih'
      this.dataSub = 'pilih'
      //this.list_bidang = []
      this.list_divisi = []
      this.list_kelompok = []
      this.list_sub = []

      this.keyrowAHSP = 0
      this.rowAHSP = []
      this.IDAHSPArray = []
      this.totalAHSPArray = []
      this.totalAHSP = 0

      this.initValues()
      this.isSidebarActiveLocal = false
    },
    eventTotal () {
      this.dataJumlah = parseFloat(this.totalAHSP)
      this.dataOverhead = parseFloat(this.dataPersentase) * this.dataJumlah / 100
      this.dataTotal = parseFloat(this.dataJumlah) + parseFloat(this.dataOverhead)
    },
    submitData () {
      this.$vs.loading()
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {

            id: this.dataId,
            task_title: this.dataAnalisa,
            task_total: this.dataTotal,
            task_unit: this.dataSatuan,
            task_price: this.dataJumlah,
            task_quantity: this.dataUkuran,
            task_parent: this.dataParent,
            task_type: 'perencanaan',
            task_sub_type: 'analisa',
            task_status: 'publish',
            task_group: 'gabungan',
            comment_status: 'null',
            task_password: 'null',

            meta : {
              persentase: this.dataPersentase,
              overhead: this.dataOverhead,
              kode: this.dataKode,
              hari: this.dataHari,
              keterangan: this.dataKeterangan
            },

            relations: {
              pekerjaan_bidang: this.dataBidang,
              pekerjaan_divisi: this.dataDivisi,
              pekerjaan_kelompok: this.dataKelompok,
              pekerjaan_sub: this.dataSub
            },

            ahsp: this.rowAHSP

          }
          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch('analisa/updateAnalisa', obj)
            .then((response) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Berhasil',
                color  : 'success',
                text  : response.message,
              })
            })
            .catch(error => {
              this.$vs.loading.close()
              let {data} = error.response
              this.$vs.notify({
                title: 'Error',
                text: data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          } else {
            delete obj.id
            this.$store.dispatch('analisa/addAnalisa', obj)
            .then((response) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Berhasil',
                color  : 'success',
                text  : response.message,
              })
            })
            .catch(error => {
              this.$vs.loading.close()
              let {data} = error.response
              this.$vs.notify({
                title: 'Error',
                text: data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          }
          this.changeBidang = false
          this.changeDivisi = false
          this.changeKelompok = false
          this.changeSub = false
          this.dataBidang = 'pilih'
          this.dataDivisi = 'pilih'
          this.dataKelompok = 'pilih'
          this.dataSub = 'pilih'
          //this.list_bidang = []
          this.list_divisi = []
          this.list_kelompok = []
          this.list_sub = []

          this.keyrowAHSP = 0
          this.rowAHSP = []
          this.IDAHSPArray = []
          this.totalAHSPArray = []
          this.totalAHSP = 0

          this.initValues()
          this.$emit('closeSidebar')
        }
      })
    }
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 750px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
